import React, { PropTypes } from 'react'
import { connect } from 'react-redux'

import * as actions from 'ducks/modules/app'
import config from 'util/config.js'

/**
 * Adapted from official React Router Prompt Component
 * https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/Prompt.js
 * 
 * Instead of using window.confirm when 'when' is true, 
 * this Component and confirmNavigation function set the message to redux state.app.blockedNavigation
 * where other components can use it to display error messages 
 */


/* 
 * This function set as Router.getUserConfirmation in App.js
 */
export const createConfirmNavigation = (store) => 
  (prompt, callback) => { 
    //TODO: Distinguish between in-app validation navigations and browser hard navigations.
    // if validation, callback false and enable validation modal/messaging
    // if hard navigation use built-in browser confirm dialog
    if (prompt) {
      store.dispatch(actions.blockNavigation(prompt));
    }
    callback(false);
  }

class NavWarning extends React.Component {
  static propTypes = {
    when: PropTypes.bool,
    message: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
    ]).isRequired
  }

  static defaultProps = {
    when: true,
    message: "Invalid"
  }

  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        block: PropTypes.func.isRequired
      }).isRequired
    }).isRequired
  }

  //return true to allow this navigation
  //return anything else to call the confirmNavigation function (above) with the return value
  prompt(location, action){ 
    if (location.pathname === '/findputter'){
      this.props.unblockNavigation()
      return true;
    }
    if (this.props.when && !config.allowInvalidNav){
      return this.props.message;
    } 
    this.props.unblockNavigation()
    return true;
  }

  // This registers this component's prompt function to be called 
  // by the BrowserRouter/History module before any navigation event.
  componentWillMount() {
    if (!this.unblock){ 
      this.prompt = this.prompt.bind(this);
      this.unblock = this.context.router.history.block(this.prompt)
    }
  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
    if (this.unblock){
      this.unblock();
      this.unblock = null;
    }
  }

  render() {
    return (this.props.when && this.props.blockedNavigation) ? <div className='error'>{this.props.message}</div> : null
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state.app}
}
const mapDispatchToProps = {
  unblockNavigation: actions.unblockNavigation
}
export default connect(mapStateToProps, mapDispatchToProps)(NavWarning);